<ds-error-message [errorList]="errorList"></ds-error-message>

<form [formGroup]="yearVinForm">
  <div class="pad-top-20 row column twelve lg-push-two md-eight md-push-two">
    <h2 class="bold-header" dsContent [contentPath]="'policy.newVehicleVinYearHeader'"></h2>

    <div class="flex column">
      <div class="row">
        <div class="sub-header">Year</div>
        <div class="column twelve">
          <ds-form-control-container
            [labelText]="yearVinForm.controls['year'].valid ? '' : 'Select a vehicle year'"
            [control]="yearVinForm.controls['year']"
          >
            <select id="year" class="icon" formControlName="year" data-cy="addVehicleYearSelect">
              <!-- <option value="unset" selected disabled>Select a vehicle year</option> -->
              @for (year of years$ | async; track year) {
                <option [value]="year">{{ year }}</option>
              }
            </select>
            <span class="icon-chevron-down"></span>
            <ds-form-control-message
              [control]="yearVinForm.controls['year']"
            ></ds-form-control-message>
          </ds-form-control-container>
        </div>
      </div>

      <div class="row">
        <div class="column twelve">
          <div class="sub-header">VIN (Vehicle Identification Number)</div>
          <ds-form-control-container
            [labelText]="vinCtrl.valid ? '' : 'Enter VIN'"
            [control]="yearVinForm.controls['vin']"
            [width]="400"
          >
            <input
              id="vin"
              formControlName="vin"
              data-cy="addVehicleVinInput"
              (input)="verifyVin()"
            />
            <ds-form-control-message
              [control]="yearVinForm.controls['vin']"
            ></ds-form-control-message>
            @if (isSameVin) {
              <div class="error-600-text caption">
                {{ sameVINErrorMessage }}
              </div>
            }
          </ds-form-control-container>
        </div>
      </div>
    </div>

    @if (errorMessage) {
      <div data-cy="addVehicleErrorMessage" class="error-600-text caption">
        {{ errorMessage }}
      </div>
    }

    <div class="row pad-top-20">
      <div class="column twelve">
        <a href="#" data-cy="yearVinFindMyVin" (click)="findVIN($event)">{{
          vinContent?.linkText
        }}</a>
      </div>
    </div>

    @if (showMsrp$ | async) {
      @if (enabledMsrp) {
        <div class="flex column twelve md-six">
          <amfam-msrp
            [parentForm]="yearVinForm"
            (vehicleDetailsLoaded)="onVehicleDetailsLoaded($event)"
          ></amfam-msrp>
        </div>
      }
    }
  </div>
  <div class="column twelve lg-push-two md-eight md-push-two">
    <call-to-action
      [displayBackButton]="true"
      [tertiaryButtonName]="'Cancel'"
      [disabled]="
        yearVinForm.invalid ||
        !vehicleDetails ||
        (roleService.isAuthorized('addvehicle_walkthrough') | async) === false
      "
      primaryButtonName="Continue"
      (primaryEvent)="submit()"
      (tertiaryEvent)="exitEvent.emit(true)"
      (backEvent)="goBackOneStep()"
    ></call-to-action>
  </div>
</form>

<ds-grace-period
  [gracePeriodDays]="gracePeriodDays$ | async"
  [(visible)]="displayPolicyGracePeriod"
  [activeAgents]="activeAgents$ | async"
  [user]="userState$ | async"
  [isPartner]="isPartner$ | async"
></ds-grace-period>

<amfam-find-vin-modal [vinContent]="vinContent" [findVinFlowModalId]="findVinFlowModalId">
</amfam-find-vin-modal>
